module.exports = __webpack_public_path__ + "img/3.3c2dcd8f.png";